<script lang="ts">
    import { onDestroy } from "svelte";
    import { similarPhrases } from "./Search.store";

    import SimilarPhrasesList from "./SimilarPhrasesList.svelte";
    import { fade } from "svelte/transition";
    import { getMessage } from "@app/services/i18n.service";
    import { SEARCH__emptyState } from "@app/services/i18n.messages";
    import { dictionary } from "@app/services/currentDictionary.service";

    let totalWords = 0;
    const similarPhrasesSubscription = similarPhrases.subscribe((val) => {
        totalWords = 0;
        if ($similarPhrases.straight && $similarPhrases.straight.words) {
            totalWords +=
                $similarPhrases.straight.beforeCount +
                $similarPhrases.straight.afterCount;
        }

        if ($similarPhrases.reverse && $similarPhrases.reverse.words) {
            totalWords +=
                $similarPhrases.reverse.beforeCount +
                $similarPhrases.reverse.afterCount;
        }
    });

    onDestroy(() => {
        similarPhrasesSubscription();
    });
</script>

<div id="sidebar-wordlist" dir={$dictionary.l1.rtl ? "rtl" : "ltr"}>
    <SimilarPhrasesList
        activeItem={$similarPhrases.straight.currentPosition}
        reverse={false}
    />
    <SimilarPhrasesList
        activeItem={$similarPhrases.reverse.currentPosition}
        reverse={true}
    />
</div>

{#if totalWords === 0}
    <div
        class="text-center py-4 px-2 text-gray-700"
        transition:fade={{ duration: 300 }}
    >
        {getMessage(SEARCH__emptyState)}
    </div>
{/if}
